import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from '../../theme';
import { useTabStyles } from './Tab.Styles';
import { Tab as HeadlessTab } from '@headlessui/react';
export const Tab = ({ children }) => {
    const theme = useTheme();
    const styles = useTabStyles({
        ...{},
        theme
    });
    return _jsx(HeadlessTab, { className: styles.tab, children: children });
};
